import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {IProject} from '../../shared/model/project.model';
import {SERVER_API_URL} from '../../app.constants';
import {createRequestOption} from '../../shared/util/request-util';


type EntityResponseType = HttpResponse<IProject>;
type EntityArrayResponseType = HttpResponse<IProject[]>;

@Injectable({providedIn: 'root'})
export class ProjectService {
  public resourceUrl = SERVER_API_URL + 'api/projects';

  constructor(protected http: HttpClient) {
  }

  create(project: IProject): Observable<EntityResponseType> {
    return this.http.post<IProject>(this.resourceUrl, project, {observe: 'response'});
  }

  update(project: IProject): Observable<EntityResponseType> {
    return this.http.put<IProject>(this.resourceUrl, project, {observe: 'response'});
  }

  updateDiscount(id: number, payload: { discount: number; discountDescription?: string }): Observable<EntityResponseType> {
    return this.http.patch<IProject>(`${this.resourceUrl}/${id}/discount`, payload, {observe: 'response'});
  }
  reform(project: IProject): Observable<EntityResponseType> {
    return this.http.put<IProject>(this.resourceUrl+'-reform', project, {observe: 'response'});
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<IProject>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  findProjectCount(): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-all-count'}`, {observe: 'response'});
  }

  findProjectMonthly(param:any,stepParam:any): Observable<HttpResponse<any>> {
    return this.http
      .get<IProject>(`${this.resourceUrl + '-monthly/'+param+'/'+stepParam}`, {observe: 'response'});
  }
  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProject[]>(this.resourceUrl, {params: options, observe: 'response'});
  }
  searchReport(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProject[]>(this.resourceUrl+'-search-report', {params: options, observe: 'response'});
  }

  searchAdvanced(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProject[]>(this.resourceUrl + '-search-advanced', {params: options, observe: 'response'});
  }

  searchReportDelete(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProject[]>(this.resourceUrl+'-search-report-delete', {params: options, observe: 'response'});
  }

  findWithCustomerId(req?: any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProject[]>(this.resourceUrl + '-customer/'+id, {params: options, observe: 'response'});
  }

  findWithSupplierId(req?: any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProject[]>(this.resourceUrl + '-supplier/'+id, {params: options, observe: 'response'});
  }

  getAllRunProject(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProject[]>(this.resourceUrl + '-run-part', {params: options, observe: 'response'});
  }

  getAllRunProjectByfilter(step?:any,req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProject[]>(this.resourceUrl + '-run-part/'+step, {params: options, observe: 'response'});
  }

  searchReportByTypeDaily(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProject[]>(this.resourceUrl + '-search-report-last', {params: options, observe: 'response'});
  }

  searchReportByTypeDailyStatus(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProject[]>(this.resourceUrl + '-search-report-last-status', {params: options, observe: 'response'});
  }

  searchDailyWithDetail(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProject[]>(this.resourceUrl + '-search-report-last-daily', {params: options, observe: 'response'});
  }

  searchDailyWithDetailAndStatus(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProject[]>(this.resourceUrl + '-search-report-last-status-daily', {params: options, observe: 'response'});
  }

  // findByStatus(req?: any, status?:any): Observable<EntityArrayResponseType> {
  //   const options = createRequestOption(req);
  //   return this.http.get<IProject[]>(this.resourceUrl + '-list-status/'+status, {params: options, observe: 'response'});
  // }

  findByStatus(req?: any, status?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProject[]>(this.resourceUrl+'-list-status/'+status, {params: options, observe: 'response'});
  }

  findProjectNoFollowUpCount(): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-noFollowUp-count'}`, {  observe: 'response' });
  }


  checkFOrArchive(id?:any): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http.get<IProject[]>(this.resourceUrl+'-check-archive/'+id, {params: null, observe: 'response'});
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }


  querySendNotify(req?: any): Observable<HttpResponse<IProject[]>> {
    const options = createRequestOption(req);

    return this.http.get<any>(this.resourceUrl+'-send-notify', { params: options, observe: 'response' });
  }
}
